/* Größentabelle (Katha, 10.10.2026): ersetzt die Sized-App.
   Daten: Shop-Metafeld custom.groessentabellen, von shopAbrechnung aus den Stücklisten und den
   Malfini-Tabellen geschrieben; snippets/groessentabelle.liquid legt die Tabellen dieses Produkts
   als JSON (#groessentabelle-daten) in die Seite. Der Link "Größentabelle" in der Zeile Größe
   (data-kr-groessentabelle) öffnet am Handy ein Fenster von unten, am Desktop eine Leiste von rechts.
   Schnitt (Unisex/Tailliert) und Größe kommen aus der Auswahl auf der Seite; eine Zeile antippen
   wählt diese Größe (und den Schnitt) auf der Produktseite. */
(function () {
  if (window.krGroessentabelle) return;
  window.krGroessentabelle = true;

  const SVG = {
    shirt: `
      <path class="hilf" d="M-28 30 H120 M-28 300 H72"/>
      <path class="mass" data-mass="laenge" d="M-20 34 V296 M-26 40 L-20 30 L-14 40 M-26 290 L-20 300 L-14 290"/>
      <text x="-14" y="170" transform="rotate(-90 -14 170)" text-anchor="middle" dy="-10">Länge</text>
      <path class="koerper" d="M120 30 Q150 52 180 30 L240 46 L292 110 L262 140 L228 120 L228 300 L72 300 L72 120 L38 140 L8 110 L60 46 Z"/>
      <path class="naht" d="M120 30 Q150 64 180 30 M72 120 Q66 88 60 46 M228 120 Q234 88 240 46"/>
      <path class="mass" data-mass="breite" d="M76 132 H224 M84 126 L74 132 L84 138 M216 126 L226 132 L216 138"/>
      <text x="150" y="124" text-anchor="middle">Breite</text>
      <path class="mass" data-mass="aermel" d="M248 36 L300 100 M243 46 L247 34 L257 39 M291 97 L301 102 L298 90"/>
      <text x="292" y="58" text-anchor="start">Ärmel</text>`,
    tailliert: `
      <path class="hilf" d="M-28 34 H122 M-28 296 H80"/>
      <path class="mass" data-mass="laenge" d="M-20 38 V292 M-26 44 L-20 34 L-14 44 M-26 286 L-20 296 L-14 286"/>
      <text x="-14" y="166" transform="rotate(-90 -14 166)" text-anchor="middle" dy="-10">Länge</text>
      <path class="koerper" d="M122 34 Q150 56 178 34 L232 48 L272 100 L250 122 L222 108 Q206 200 226 296 L74 296 Q94 200 78 108 L50 122 L28 100 L68 48 Z"/>
      <path class="naht" d="M122 34 Q150 62 178 34 M78 108 Q72 80 68 48 M222 108 Q228 80 232 48"/>
      <path class="mass" data-mass="breite" d="M82 120 H218 M90 114 L80 120 L90 126 M210 114 L220 120 L210 126"/>
      <text x="150" y="112" text-anchor="middle">Breite</text>
      <path class="mass" data-mass="aermel" d="M240 40 L281 92 M235 50 L239 38 L249 43 M272 89 L282 94 L279 82"/>
      <text x="276" y="56" text-anchor="start">Ärmel</text>`,
    hoodie: `
      <path class="hilf" d="M-28 80 H112 M-28 310 H68"/>
      <path class="mass" data-mass="laenge" d="M-20 84 V306 M-26 90 L-20 80 L-14 90 M-26 300 L-20 310 L-14 300"/>
      <text x="-14" y="195" transform="rotate(-90 -14 195)" text-anchor="middle" dy="-10">Länge</text>
      <path class="koerper" d="M112 74 Q100 10 150 6 Q200 10 188 74 L232 86 L300 252 L276 262 L232 168 L232 310 L68 310 L68 168 L24 262 L0 252 L68 86 Z"/>
      <path class="naht" d="M120 72 Q118 26 150 22 Q182 26 180 72 Q150 94 120 72 M68 86 Q76 126 68 168 M232 86 Q224 126 232 168 M68 296 H232 M100 214 H200 L212 264 H88 Z"/>
      <path class="mass" data-mass="breite" d="M72 164 H228 M80 158 L70 164 L80 170 M220 158 L230 164 L220 170"/>
      <text x="150" y="156" text-anchor="middle">Breite</text>
      <path class="mass" data-mass="aermel" d="M242 78 L310 244 M236 86 L241 74 L250 82 M302 237 L311 247 L313 234"/>
      <text x="284" y="146" text-anchor="start">Ärmel</text>`,
    zipper: `
      <path class="hilf" d="M-28 76 H120 M-28 310 H68"/>
      <path class="mass" data-mass="laenge" d="M-20.0 76.0 L-20.0 310.0 M-25.0 85.6 L-20.0 76.0 L-15.0 85.6 M-25.0 300.4 L-20.0 310.0 L-15.0 300.4"/>
      <text x="-14" y="195" transform="rotate(-90 -14 195)" text-anchor="middle" dy="-10">Länge</text>
      <path class="koerper" d="M118 72 Q104 8 150 4 Q196 8 182 72 L230 92 L300 252 L276 262 L232 168 L232 310 L68 310 L68 168 L24 262 L0 252 L70 92 Z"/>
      <path class="naht" d="M124 72 Q120 24 150 20 Q180 24 176 72 M120 76 L68 168 M180 76 L232 168 M68 296 H232 M9 238 L31 248 M291 238 L269 248 M86 218 L98 262 M214 218 L202 262"/>
      <path class="naht zip" d="M150 84 V310"/>
      <path class="mass" data-mass="breite" d="M72.0 164.0 L228.0 164.0 M81.6 169.0 L72.0 164.0 L81.6 159.0 M218.4 169.0 L228.0 164.0 L218.4 159.0"/>
      <text x="112" y="156" text-anchor="middle">Breite</text>
      <path class="mass" data-mass="aermel" d="M186.0 62.0 L236.0 83.0 L309.0 248.0 M196.8 61.1 L186.0 62.0 L192.9 70.3 M300.5 241.2 L309.0 248.0 L309.7 237.2"/>
      <text x="276" y="150" text-anchor="start">Ärmel</text>`,
    jacke: `
      <path class="hilf" d="M-28 40 H114 M-28 300 H68"/>
      <path class="mass" data-mass="laenge" d="M-20.0 40.0 L-20.0 300.0 M-25.0 49.6 L-20.0 40.0 L-15.0 49.6 M-25.0 290.4 L-20.0 300.0 L-15.0 290.4"/>
      <text x="-14" y="170" transform="rotate(-90 -14 170)" text-anchor="middle" dy="-10">Länge</text>
      <path class="koerper" d="M114 40 Q150 60 186 40 L232 54 L300 232 L276 242 L232 140 L232 300 L68 300 L68 140 L24 242 L0 232 L68 54 Z"/>
      <path class="naht" d="M120 46 Q150 70 180 46 M150 64 V300 M68 54 Q76 98 68 140 M232 54 Q224 98 232 140 M68 280 H232 M68 287 H232 M68 292 H232 M7 222 L29 231 M293 222 L271 231 M10 215 L32 224 M290 215 L268 224 M84 200 L92 240 M216 200 L208 240"/>
      <g class="knopf"><circle cx="150" cy="90" r="3.5"/><circle cx="150" cy="130" r="3.5"/><circle cx="150" cy="170" r="3.5"/><circle cx="150" cy="210" r="3.5"/><circle cx="150" cy="250" r="3.5"/></g>
      <path class="mass" data-mass="breite" d="M72.0 136.0 L228.0 136.0 M81.6 141.0 L72.0 136.0 L81.6 131.0 M218.4 141.0 L228.0 136.0 L218.4 131.0"/>
      <text x="112" y="128" text-anchor="middle">Breite</text>
      <path class="mass" data-mass="aermel" d="M188.0 32.0 L238.0 46.0 L308.0 228.0 M198.6 29.8 L188.0 32.0 L195.9 39.4 M299.9 220.8 L308.0 228.0 L309.2 217.2"/>
      <text x="276" y="128" text-anchor="start">Ärmel</text>`,
  };
  const SIZE_ALIASES = { XXL: '2XL', XXXL: '3XL' };
  const norm = (value) => {
    const size = String(value || '').trim().toUpperCase().replace(/\s+/g, '');
    return SIZE_ALIASES[size] || size;
  };
  const fmt = (value) => String(value).replace('.', ',');
  const touch = window.matchMedia('(pointer: coarse)').matches;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let root = null;
  let state = null;
  let opener = null;

  function data() {
    const node = document.getElementById('groessentabelle-daten');
    if (!node) return null;
    try {
      const parsed = JSON.parse(node.textContent);
      const entries = (parsed.entries || []).filter((entry) => parsed.charts && parsed.charts[entry.chart]);
      return entries.length ? { entries, charts: parsed.charts } : null;
    } catch (error) {
      return null;
    }
  }

  function picker() {
    return document.querySelector('.product__info-container variant-selects') || document.querySelector('variant-selects');
  }

  function checkedValues() {
    const scope = picker();
    if (!scope) return [];
    const values = [...scope.querySelectorAll('input[type=radio]:checked')].map((input) => input.value);
    scope.querySelectorAll('select').forEach((select) => values.push(select.value));
    return values;
  }

  function findInput(value, matcher) {
    const scope = picker();
    if (!scope) return null;
    return [...scope.querySelectorAll('input[type=radio]')].find((input) => matcher(input.value, value)) || null;
  }

  function build() {
    root = document.createElement('div');
    root.className = 'kr-gt';
    root.hidden = true;
    root.innerHTML =
      '<div class="kr-gt__schatten" data-kr-gt-zu></div>' +
      '<div class="kr-gt__fenster" role="dialog" aria-modal="true" aria-labelledby="kr-gt-titel">' +
      '<div class="kr-gt__kopf"><div><p class="kr-gt__art"></p><h2 class="kr-gt__titel" id="kr-gt-titel">Größentabelle</h2></div>' +
      '<button type="button" class="kr-gt__zu" data-kr-gt-zu aria-label="Größentabelle schließen">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button></div>' +
      '<div class="kr-gt__inhalt"></div></div>';
    document.body.appendChild(root);
    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-kr-gt-zu]')) return close();
      const cut = event.target.closest('[data-kr-gt-schnitt]');
      if (cut) {
        state.index = Number(cut.dataset.krGtSchnitt);
        return render();
      }
      const row = event.target.closest('[data-kr-gt-groesse]');
      if (row) choose(row.dataset.krGtGroesse);
    });
    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
      if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('[data-kr-gt-groesse]')) {
        event.preventDefault();
        choose(event.target.dataset.krGtGroesse);
      }
      if (event.key === 'Tab') trap(event);
    });
  }

  function trap(event) {
    const focusable = [...root.querySelectorAll('button, [tabindex="0"]')].filter((node) => node.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function open(link) {
    const found = data();
    if (!found) return;
    if (!root) build();
    const values = checkedValues();
    let index = found.entries.findIndex((entry) => entry.cut && values.includes(entry.cut));
    if (index < 0) index = 0;
    const chart = found.charts[found.entries[index].chart];
    const size = values.map(norm).find((value) => chart.sizes.map(norm).includes(value)) || '';
    state = { ...found, index, size };
    opener = link;
    render();
    root.hidden = false;
    document.documentElement.classList.add('kr-gt-offen');
    requestAnimationFrame(() => root.classList.add('is-offen'));
    root.querySelector('.kr-gt__zu').focus({ preventScroll: true });
  }

  function close() {
    if (!root || root.hidden) return;
    root.classList.remove('is-offen');
    document.documentElement.classList.remove('kr-gt-offen');
    const done = () => {
      root.hidden = true;
    };
    if (reduce) done();
    else setTimeout(done, 220);
    if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
    else {
      const link = document.querySelector('[data-kr-groessentabelle]');
      if (link) link.focus({ preventScroll: true });
    }
  }

  function render() {
    const entry = state.entries[state.index];
    const chart = state.charts[entry.chart];
    const cuts = state.entries.length > 1 && state.entries.every((item) => item.cut);
    const highlight = norm(state.size);
    const tip = { shirt: 'Miss dein Lieblingsshirt flach aus ♡', tailliert: 'Miss dein Lieblingsshirt flach aus ♡', jacke: 'Miss deine Lieblingsjacke flach aus ♡', zipper: 'Miss deinen Lieblingszipper flach aus ♡' }[chart.form] || 'Miss deinen Lieblingshoodie flach aus ♡';
    root.querySelector('.kr-gt__art').textContent = chart.art || '';
    const rows = chart.sizes
      .map((size, index) => {
        const chosen = norm(size) === highlight;
        return (
          '<tr tabindex="0" role="button" data-kr-gt-groesse="' + size + '" class="' + (chosen ? 'is-gewaehlt' : '') + '" aria-label="Größe ' + size + ' wählen"' + (chosen ? ' aria-current="true"' : '') + '>' +
          '<td>' + size + '</td>' +
          ['laenge', 'breite', 'aermel'].map((key) => (chart.rows[key] ? '<td>' + fmt(chart.rows[key][index]) + '</td>' : '')).join('') +
          '</tr>'
        );
      })
      .join('');
    const heads = [['laenge', 'Länge'], ['breite', 'Breite'], ['aermel', 'Ärmel']]
      .filter(([key]) => chart.rows[key])
      .map(([, label]) => '<th scope="col">' + label + '<span>cm</span></th>')
      .join('');
    const explain = [['laenge', 'Länge'], ['breite', 'Breite'], ['aermel', 'Ärmel']]
      .filter(([key]) => chart.rows[key] && chart.texts && chart.texts[key])
      .map(([key, label]) => '<li><b>' + label + '</b>: ' + chart.texts[key] + '</li>')
      .join('');
    root.querySelector('.kr-gt__inhalt').innerHTML =
      (cuts
        ? '<div class="kr-gt__schnitt" role="group" aria-label="Schnitt">' +
          state.entries.map((item, index) => '<button type="button" data-kr-gt-schnitt="' + index + '" aria-pressed="' + (index === state.index) + '">' + item.cut + '</button>').join('') +
          '</div>'
        : '') +
      '<p class="kr-gt__tipp">' + tip + '</p>' +
      '<div class="kr-gt__bild"><svg viewBox="-50 0 370 320" role="img" aria-label="So wird gemessen">' + (SVG[chart.form] || SVG.shirt) + '</svg></div>' +
      '<table class="kr-gt__tabelle"><thead><tr><th scope="col">Größe</th>' + heads + '</tr></thead><tbody>' + rows + '</tbody></table>' +
      '<p class="kr-gt__waehlen">' + (touch ? 'Tippe' : 'Klicke') + ' auf eine Zeile, um die Größe zu wählen.</p>' +
      '<ul class="kr-gt__erklaerung">' + explain + '</ul>' +
      compare(cuts) +
      '<p class="kr-gt__klein">' + [chart.material, 'Maße in cm', chart.tolerance].filter(Boolean).join('. ') + '.</p>';
  }

  /* Bei zwei Schnitten: dieselbe Größe im anderen Schnitt, damit man nicht hin und her schalten muss. */
  function compare(cuts) {
    if (!cuts) return '';
    const chart = state.charts[state.entries[state.index].chart];
    const size = chart.sizes.find((item) => norm(item) === norm(state.size)) || chart.sizes[Math.floor(chart.sizes.length / 2)];
    const lines = state.entries
      .filter((item, index) => index !== state.index)
      .map((item) => {
        const other = state.charts[item.chart];
        const index = other.sizes.map(norm).indexOf(norm(size));
        if (index < 0 || !other.rows.breite || !other.rows.laenge) return '';
        return item.cut + ' ' + size + ' ist ' + fmt(other.rows.breite[index]) + ' cm breit und ' + fmt(other.rows.laenge[index]) + ' cm lang.';
      })
      .filter(Boolean);
    return lines.length ? '<p class="kr-gt__vergleich">' + lines.join(' ') + '</p>' : '';
  }

  /* Größe (und Schnitt) auf der Produktseite wählen. Dawn rendert die Auswahl nach jeder Änderung neu,
     deshalb erst den Schnitt setzen und auf die neue Auswahl warten, dann die Größe. */
  function choose(size) {
    state.size = size;
    render();
    const entry = state.entries[state.index];
    const values = checkedValues();
    const pickSize = () => {
      const input = findInput(size, (value, wanted) => norm(value) === norm(wanted));
      if (input && !input.checked) input.click();
      setTimeout(close, reduce ? 0 : 350);
    };
    if (entry.cut && !values.includes(entry.cut)) {
      const cutInput = findInput(entry.cut, (value, wanted) => value === wanted);
      if (cutInput) {
        waitForPicker(pickSize);
        cutInput.click();
        return;
      }
    }
    pickSize();
  }

  function waitForPicker(callback) {
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      callback();
    };
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      const unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => {
        if (typeof unsubscribe === 'function') unsubscribe();
        setTimeout(finish, 0);
      });
    }
    setTimeout(finish, 900);
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('[data-kr-groessentabelle]');
    if (!link) return;
    event.preventDefault();
    open(link);
  });
})();
